import Vue from 'vue';
import VueI18n from 'vue-i18n';
import eventBus from '@/eventBus';
Vue.use(VueI18n);

const browserLang = navigator.language || navigator.userLanguage;
const defaultLang = browserLang.includes('zh') ? 'zh-CN' : 'en';

// 从本地存储获取语言偏好，默认为中文
const locale = localStorage.getItem('locale') || defaultLang;

// 加载语言文件
const messages = {
  'en': require('./locales/en.json'),
  'zh-CN': require('./locales/zh-CN.json')
};

// 创建i18n实例
const i18n = new VueI18n({
  locale,
  messages,
  fallbackLocale: 'zh-CN', // 语言包缺失时的回退语言
  silentFallbackWarn: true // 关闭回退警告
});

// 监听locale变化并触发事件
new Vue({ i18n, watch: { '$i18n.locale'(newLocale) {
  localStorage.setItem('locale', newLocale);
  eventBus.$emit('localeChanged');
}}});

export default i18n;